import { UnderlineInput } from './underline_input';
export const OutsidePageContent = React.createClass({
	displayName: 'OutsidePageContent',
	propTypes: {
		title: React.PropTypes.string,
		description: React.PropTypes.node,
		inputPlaceHolder: React.PropTypes.string,
		onInputChange: React.PropTypes.func,
		cancelButtonText: React.PropTypes.string,
		confirmButtonText: React.PropTypes.string,
		onCancel: React.PropTypes.func,
		onConfirm: React.PropTypes.func,
		isLoading: React.PropTypes.bool,
		backgroundColor: React.PropTypes.string,
		message: React.PropTypes.node,
		mobile: React.PropTypes.bool,
		confirmGhost: React.PropTypes.bool
	},
	getDefaultProps() {
		return {
			title: '',
			description: '',
			inputPlaceHolder: 'Input some text',
			cancelButtonText: '',
			confirmButtonText: '',
			onInputChange: function() {},
			onCancel: function() {},
			onConfirm: function() {},
			isLoading: false,
			confirmGhost: false,
			mssage: '',
			showInput: true,
			backgroundColor: '#fff',
			mobile: React.PropTypes.bool,
			smallScreenHeight: 618,

		}
	},
	parseDescription(description) {
		if(typeof description == 'string') {
			return description.split("<br/>").map(i => {
        		return (<div>{i}</div>);
    		});
		}
		return description;
	},
	getButtonCount() {
		if(this.props.confirmButtonText == '' && this.props.confirmButtonText == '') {
			return 0;
		}

		if(this.props.confirmButtonText != '' && this.props.confirmButtonText != '') {
			return 2;
		}
		return 1;
	},
	getContentViewStyle() {
		return {
			backgroundColor: this.props.backgroundColor,
			height: this.props.height, 
			marginTop: -this.props.height / 2 - (this.props.mobile ? 50 : -10)
		};	
	},
	render() {
		return (
			<div className="outside-page-content-view" style={this.getContentViewStyle()}>
				<div className="outside-page-title">{this.props.title}</div>
				<div className="outside-page-desc">
				 	{this.parseDescription(this.props.description)}
				 </div>
				<div className="outside-page-input-container">
					{this.props.showInput ? 
						<UnderlineInput value={this.props.inputValue} placeHolder={this.props.inputPlaceHolder} onChange={this.props.onInputChange} />
						: null
					}
				</div>
				<div className={`outside-page-message ${this.props.status ? '' : 'outside-page-error-message'}`}>
					{this.props.message}
				</div>
				<div className={`outside-page-buttons outside-page-buttons-${this.getButtonCount()}`}>
					{
						this.props.cancelButtonText == '' ? 
							null : <button className="gray-btn outside-page-btn" onClick={this.props.onCancel}> { this.props.cancelButtonText } </button>
					}
					{
						this.props.confirmButtonText == '' ? 
							null : <button className={`blue-btn outside-page-btn ${this.props.isLoading ? 'loading' : ''} ${this.props.confirmGhost ? 'ghost-blue-button' : ''}`} onClick={this.props.onConfirm}> { this.props.confirmButtonText } </button>
					}
				</div>
			</div>
		);
	}
});


// WEBPACK FOOTER //
// ../modules/js/v3/components/outside_page_content.js